<template>
  <v-alert v-if="alert" :type="alert.type" :class="alert.class" :value="true" :icon="icon">
    {{ $$t(alert.text) }}
  </v-alert>
</template>

<script>
import { mdiAlertDecagram } from '@mdi/js';
import { mapState } from 'vuex';
import states from '../states.json';

export default {
  name: 'ReadinessDisplay',
  module: 'Membership',
  props: {
    type: {
      type: String,
      default: 'green',
    },
  },
  data() {
    return {
      states,
    };
  },
  computed: {
    ...mapState('mapItems', ['myLocation']),
    alert() {
      return this.states
        .find((s) => s.text.toLowerCase() === this.myLocation?.state?.toLowerCase());
    },
    icon() {
      if (this.alert?.type === 'black') {
        return mdiAlertDecagram;
      }
      return undefined;
    },
  },
};
</script>
